







import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import StripeIntegration from '@/web/components/settings/StripeIntegration.vue';

export default Vue.extend({
  components: {
    TopNav,
    StripeIntegration,
  },
});
